import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h2 className="section-title">about us</h2>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ea aliquam ratione voluptas veniam eaque possimus quasi, dignissimos voluptates in, velit rem accusantium molestias deleniti nobis reprehenderit laborum! Similique dolorem eius totam magni, voluptatum quae amet enim, reiciendis consequuntur ullam neque libero quasi at quo nulla officiis distinctio impedit obcaecati ex.</p>
    </section>
  );
}

export default About
